import React, { useEffect } from "react";
import back from "../../Asset/product/back.png";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Privacy = () => {
const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  useEffect(() => {
    AOS.init();
}, [])
  return (
    <div
      className="w-full bg-Background3 pl:5 pr-5 md:pl-20 md:pr-20 md:pt-20 md:pb-44 overflow-x-hidden"
      style={{ backgroundImage: `url(${back})` }}
    >
      <div className="bg-white/50 p-4  rounded-3xl">
        <div className="w-full my-10">
          <span className="text-textColor font-semibold text-3xl">
            Privacy Policy
          </span>
        </div>
        <div className="w-full">
          <div className="my-2" data-aos="fade-up">
            <span className="text-textColor text-2xl font-semibold ">
              Introduction
            </span>
            <p className="text-textColor" >
              Welcome to Sehatful. We are committed to protecting your privacy
              and ensuring the security of your personal information. This
              Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our website
              (www.sehatful.com) and mobile application (collectively, the
              "Service").
            </p>
            <p className="text-textColor" >
              By accessing or using our Service, you agree to the terms of this
              Privacy Policy. If you do not agree with our policies and
              practices, please do not use our Service.
            </p>
          </div>
          <div className="my-2" data-aos="fade-up" >
            <span className="text-textColor text-2xl font-semibold mt-2">
              Information We Collect
            </span>
              Information We Collect
            <p className="text-textColor" >
              We collect several types of information from and about users of
              our Service, including:
            </p>
          </div>
          <div className="my-2" data-aos="fade-up">
            <span className="text-textColor text-xl font-semibold mt-4">
              Personal Information
            </span>
            <p className="text-textColor" >
              {" "}
              &bull; Contact Information: Name, email address, phone number,
              shipping and billing addresses
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Account Information: Username, password, profile picture
            </p>
            <p className="text-textColor" >
              {" "}
              &bull; Payment Information: Credit/debit card details, payment
              gateway information (processed securely by our third-party payment
              processors)
            </p>
            <p className="text-textColor" > &bull; Demographic Information: Age, gender, preferences</p>
            <p className="text-textColor ">
              {" "}
              &bull; Health Information: Dietary preferences, allergies (only
              when voluntarily provided for product recommendations)
            </p>
          </div>
          <div className="my-2" data-aos="fade-up">
            <span className="text-textColor text-xl font-semibold">
              Non-Personal Information
            </span>
            <p className="text-textColor">
              {" "}
              &bull; Device Information: IP address, browser type, operating
              system, mobile device identifiers
            </p>
            <p className="text-textColor" >
              {" "}
              &bull; Usage Data: Pages visited, time spent, clickstream data,
              search queries
            </p>

            <p className="text-textColor">
              {" "}
              &bull; Cookies and Tracking Technologies: See Section 5 for
              details
            </p>
          </div>
          <div className="my-2" data-aos="fade-up">
            <span className="text-textColor text-xl font-semibold">
              Information from Third Parties
            </span>
            <p className="text-textColor">
              We may receive information about you from third parties, such as
              social media platforms when you choose to connect your account, or
              marketing partners.
            </p>
            <span className="text-textColor text-xl font-semibold">
              How We Use Your Information
            </span>
            <p className="text-textColor">
              We use the information we collect for various purposes, including:
            </p>
            <p className="text-textColor"> &bull; To provide, operate, and maintain our Service</p>
            <p className="text-textColor"> &bull; To process your orders and deliver organic products</p>
            <p className="text-textColor">
              {" "}
              &bull; To authenticate your account and provide customer support
            </p>
            <p className="text-textColor"> &bull; To personalize your experience and recommend products</p>
            <p className="text-textColor">
              {" "}
              &bull; To communicate with you about orders, accounts, and
              promotions
            </p>
            <p className="text-textColor"> &bull; To detect and prevent fraud and security issues</p>
            <p className="text-textColor">
              {" "}
              &bull; To comply with legal obligations and enforce our terms
            </p>
          </div>
          <div className="my-2" data-aos="fade-up">
            <span className="text-textColor text-2xl font-semibold">
              How We Share Your Information
            </span>
            <p  className="text-textColor">We may share your information in the following circumstances:</p>
            <span className="text-textColor text-xl font-semibold">
              Service Providers
            </span>
            <p className="text-textColor"> &bull; Payment processors</p>
            <p className="text-textColor"> &bull; Shipping and delivery partners</p>
            <p className="text-textColor"> &bull; Marketing and analytics providers</p>
            <p className="text-textColor"> &bull; Customer support platforms</p>
            <p className="text-textColor"> &bull; Cloud storage providers</p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            Business Transfers
          </span>
          <p className="text-textColor">
            In the event of a merger, acquisition, or sale of assets, your
            information may be transferred as part of the transaction.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            Legal Requirements
          </span>
          
          <p className="text-textColor">
            We may disclose information if required by law or in response to
            valid requests by public authorities.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            With Your Consent
          </span>
          <p className="text-textColor">
            We may share information with third parties when we have your
            explicit consent to do so.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-2xl font-semibold">
            Cookies and Tracking Technologies
          </span>
          <p className="text-textColor">We use cookies and similar tracking technologies to:</p>
          <p className="text-textColor"> &bull; Remember your preferences and login information</p>
          <p className="text-textColor"> &bull; Analyze website traffic and usage patterns</p>
          <p className="text-textColor"> &bull; Deliver targeted advertisements</p>
          <p className="text-textColor"> &bull; Improve our Service</p>
          <p className="text-textColor">
            You can control cookies through your browser settings. However,
            disabling cookies may affect your experience with our Service.
          </p>
          <p className="text-textColor">
            We may use third-party analytics services like Google Analytics to
            help analyze how users use our Service.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-2xl font-semibold">
            Data Security
          </span>
          <p className="text-textColor">
            We implement appropriate technical and organizational measures to
            protect your personal information, including:
          </p>
          <p className="text-textColor"> &bull; SSL/TLS encryption for data transmission</p>
          <p className="text-textColor"> &bull; Secure storage with access controls</p>
          <p className="text-textColor"> &bull; Regular security assessments</p>
          <p className="text-textColor"> &bull; Employee training on data protection</p>
          <p className="text-textColor">
            However, no method of transmission over the Internet or electronic
            storage is 100% secure. We cannot guarantee absolute security.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-2xl font-semibold">
            Your Rights and Choices
          </span>
          <p className="text-textColor">
            Depending on your location, you may have certain rights regarding
            your personal information:
          </p>
          <p className="text-textColor"> &bull; Access: Request a copy of your personal data</p>
          <p className="text-textColor"> &bull; Correction: Update or correct inaccurate information</p>
          <p className="text-textColor"> &bull; Restriction: Request restriction of processing</p>
          <p className="text-textColor">
            {" "}
            &bull; Portability: Request transfer of your data to another service
          </p>
          <p className="text-textColor"> &bull; Objection: Object to certain processing activities</p>
          <p className="text-textColor">
            {" "}
            &bull; Marketing Preferences: Opt-out of marketing communications
          </p>
          <p className="text-textColor">
            To exercise these rights, please contact us at
            privacy@merahealth.com. We may need to verify your identity before
            processing your request.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-2xl font-semibold">
            International Data Transfers
          </span>
          <p className="text-textColor">
            Your information may be transferred to and processed in countries
            other than your own. We ensure appropriate safeguards are in place
            for these transfers, such as standard contractual clauses or other
            legal mechanisms.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            Children's Privacy
          </span>
          <p className="text-textColor">
            Our Service is not intended for children under 16. We do not
            knowingly collect personal information from children under 16. If we
            become aware of such collection, we will take steps to delete the
            information.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            Third-Party Links
          </span>
          <p className="text-textColor">
            Our Service may contain links to third-party websites. This Privacy
            Policy does not apply to those sites. We encourage you to review the
            privacy policies of any third-party sites you visit.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-xl font-semibold">
            Changes to This Privacy Policy
          </span>
          <p className="text-textColor">
            We may update this Privacy Policy periodically. We will notify you
            of significant changes by posting the new policy on our Service and
            updating the "Last Updated" date. Your continued use of the Service
            after such changes constitutes acceptance of the updated policy.
          </p>
          </div>
          <div className="my-2" data-aos="fade-up">
          <span className="text-textColor text-2xl font-semibold">
            Contact Us
          </span>
          <p className="text-textColor">
            If you have any questions about this Privacy Policy or our privacy
            practices, please contact us at:
          </p>
          <p className="text-textColor font-semibold">SEHATFUL SOLUTIONS PRIVATE LIMITED</p>
          <p className="text-textColor">Email: privacy@sehatful.com</p>
          <p className="text-textColor">Phone: +91 7411672999</p>
          <p className="text-textColor">
          Site Number 27, Next to Sobha Sentosa , Balagere Village, Kundalahalli, Bangalore North, Bangalore- 560037, Karnataka
          </p>
          <p className="text-textColor">© 2025 Sehatful. All rights reserved.</p></div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
